import { render, staticRenderFns } from "./LpaTable.vue?vue&type=template&id=5f290afa&"
import script from "./LpaTable.vue?vue&type=script&lang=js&"
export * from "./LpaTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports